export default class AlunoService {
  constructor(resource) {
    this._resource = resource;
  }

  temDebitosParaNegociar(ra) {
    return this._resource.get(`corpore/debitos-negociacao/aluno/${ra}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os debitos");
      }
    );
  }

  getDebitosAluno(ra, coligada = 1) {
    return this._resource.get(`corpore/debitos/aluno/${ra}/${coligada}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os debitos");
      }
    );
  }

  getResponsavelFinanceiro(ra) {
    return this._resource.get(`corpore/responsavel/${ra}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível o responsável financeiro");
      }
    );
  }

  getDebitosMaterialDidatico(cpf) {
    return this._resource.get(`corpore/debitos/material/${cpf}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os debitos");
      }
    );
  }

  getDebitosResponsavel(cpf) {
    return this._resource.get(`corpore/debitos/responsavel/${cpf}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os debitos");
      }
    );
  }

  getCursosAlunoByRa(ra, ativo = null, modalidadeId = null) {
    return this._resource
      .get(`corpore/aluno/curso/${ra}`, {
        params: {
          ativo,
          modalidadeId
        }
      })
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter os cursos");
        }
      );
  }

  getAllCursosAlunoByRa(ra, ativo = null, filialId) {
    return this._resource.get(`corpore/aluno/curso/all/${ra}`, {
      params: {
        ativo,
        filialId
      }
    }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os cursos");
      }
    );
  }

  getCursosGraduacaoAlunoByRa(ra) {
    return this._resource.get(`corpore/aluno/curso/graduacao/${ra}`).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os cursos");
      }
    );
  }

  getAlunosByTurmaDisc(turmadisc) {
    return this._resource.post("corpore/aluno/by/turmas", turmadisc).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os alunos");
      }
    );
  }

  getAlunosByModalidade(modalidadeId, cursos, polos) {
    return this._resource.post("corpore/aluno/by/modalidade", {
      modalidades: modalidadeId,
      cursos: cursos,
      polos: polos
    }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os alunos");
      }
    );
  }

  getPercentualConcluido(ra, idHabilitacaoFilial) {
    return this._resource
      .get(`corpore/aluno/percentual-cursado/${ra}/${idHabilitacaoFilial}`)
      .then(
        res => res.json(),
        err => {
          console.log(err);
          throw new Error("Não foi possível obter o percentual de conclusão");
        }
      );
  }

  getDocumentosPendentesByRa(ra) {
    return this._resource.post("corpore/documentos-pendentes", {
      ra: ra
    }).then(
      res => res.json(),
      err => {
        console.log(err);
        throw new Error("Não foi possível obter os documentos pendentes");
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/domain/corpore/AlunoService.js